import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * The re3 header and footer reference their logos and icons through
 * `<use xlink:href="#icon-...">`, the same way https://re3.fccenvironment.co.uk does.
 *
 * External sprite references (`<use href="sprite.svg#id">`) are not supported by
 * Safari, so the sprite is fetched once and injected into the document instead.
 * Keeping it in an asset file rather than index.html means it stays cacheable and
 * out of the JS bundle.
 */
@Injectable({ providedIn: 'root' })
export class IconSpriteService {
  private static readonly SPRITE_URL = 'assets/images/icons/symbol-defs.svg';
  private static readonly CONTAINER_ID = 're3-icon-sprite';

  constructor(private http: HttpClient) {}

  inject(): void {
    if (document.getElementById(IconSpriteService.CONTAINER_ID)) {
      return;
    }

    this.http
      .get(IconSpriteService.SPRITE_URL, { responseType: 'text' })
      .subscribe({
        next: (sprite) => {
          const container = document.createElement('div');
          container.id = IconSpriteService.CONTAINER_ID;
          container.setAttribute('aria-hidden', 'true');
          container.style.position = 'absolute';
          container.style.width = '0';
          container.style.height = '0';
          container.style.overflow = 'hidden';
          container.innerHTML = sprite;
          document.body.insertBefore(container, document.body.firstChild);
        },
        error: (err) => console.error('Unable to load the re3 icon sprite', err),
      });
  }
}
